<template>
    <div class="kanban-summary" v-if="records && records.length > 0">
        <div class="dropdown-summary">
            <div
                v-for="dist in getDropdownDistribution()"
                :key="dist.value"
                class="summary-option-chip"
                :style="{
                    backgroundColor: dist.color,
                    flexGrow: dist.flexValue
                }"
                v-tippy="{ content: getDropdownTooltip(dist) }"
            >
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "KanbanSummary",
    props: {
        records: {
            type: Array,
            default: () => [],
        },
        selectedField: {
            type: String,
            required: true,
        },
        kanbanField: {
            type: Object,
            default: null,
        },
    },
    methods: {
        getDropdownDistribution() {
            if (!this.kanbanField || !this.records) return [];

            var distribution = {};
            var totalCount = 0;
            
            this.records.forEach(record => {
                const value = record.data[this.selectedField];
                if (Array.isArray(value)) {
                    value.forEach(multiVal => {
                        if (!distribution[multiVal]) {
                            distribution[multiVal] = 0;
                        }
                        distribution[multiVal]++;
                        totalCount++;
                    });
                } else if (value) {
                    if (!distribution[value]) {
                        distribution[value] = 0;
                    }
                    distribution[value]++;
                    totalCount++;
                }
            });

            const options = this.kanbanField.options?.dropdown?.options || [];

            const resultArray = Object.keys(distribution).map(key => {
                const count = distribution[key];
                const colorVal = this.findOptionColor(key, options) || this.generateColorFromText(key);
                const ratio = count / totalCount;
                
                return {
                    value: key,
                    count: count,
                    color: colorVal,
                    flexValue: ratio * 10,
                    ratio: ratio,
                };
            });

            console.log("getDropdownDistribution", resultArray);
            return resultArray.sort((a, b) => b.count - a.count);
        },

        getDropdownTooltip(dist) {
            const percentage = (dist.ratio * 100).toFixed(2);
            return `${dist.value} | Count: ${dist.count} | Percentage: ${percentage}%`;
        },

        findOptionColor(value, options) {
            const option = options.find(opt => opt.value === value);
            return option ? option.color : null;
        },

        generateColorFromText(text) {
            let hash = 0;
            for (let i = 0; i < text.length; i++) {
                hash = text.charCodeAt(i) + ((hash << 5) - hash);
            }
            const hue = Math.abs(hash) % 360;
            const saturation = 25 + (Math.abs(hash) % 15);
            const lightness = 85 + (Math.abs(hash) % 10);
            return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
        },
    },
});
</script>

<style scoped lang="scss">
.kanban-summary {
    width: 200px;

    .dropdown-summary {
        min-height: 35px;
        display: flex;
        align-items: center;
        border: 1px solid #ddd;
        border-radius: 4px;
        overflow: unset !important;

        .summary-option-chip {
            overflow: unset !important;
            transition: transform 0.2s ease;
            cursor: pointer;

            &:hover {
                transform: scaleY(1.2);
                height: 110%;
            }
        }
    }
}
</style> 